import { LoaderFunctionArgs } from 'react-router-dom';
import { fetchWarehouse } from '../WarehousesPage/services';

export const warehouseLoader = async ({ params }: LoaderFunctionArgs) => {
  const id = String(params.id);

  if (id === 'new') {
    return { data: null };
  }

  try {
    const data = await fetchWarehouse({ id });
    return { data };
  } catch (error) {
    return { data: null };
  }
};
